/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type FreshdeskCredentials = {
  domain: string;
  apiKey: string;
};

/** @internal */
export const FreshdeskCredentials$inboundSchema: z.ZodType<
  FreshdeskCredentials,
  z.ZodTypeDef,
  unknown
> = z.object({
  domain: z.string(),
  api_key: z.string(),
}).transform((v) => {
  return remap$(v, {
    "api_key": "apiKey",
  });
});
/** @internal */
export type FreshdeskCredentials$Outbound = {
  domain: string;
  api_key: string;
};

/** @internal */
export const FreshdeskCredentials$outboundSchema: z.ZodType<
  FreshdeskCredentials$Outbound,
  z.ZodTypeDef,
  FreshdeskCredentials
> = z.object({
  domain: z.string(),
  apiKey: z.string(),
}).transform((v) => {
  return remap$(v, {
    apiKey: "api_key",
  });
});

export function freshdeskCredentialsToJSON(
  freshdeskCredentials: FreshdeskCredentials,
): string {
  return JSON.stringify(
    FreshdeskCredentials$outboundSchema.parse(freshdeskCredentials),
  );
}
export function freshdeskCredentialsFromJSON(
  jsonString: string,
): SafeParseResult<FreshdeskCredentials, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => FreshdeskCredentials$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'FreshdeskCredentials' from JSON`,
  );
}
